import React from 'react'

const Backend = () => {
  return (
    <div className='skills__content'>
    <h3 className='skills__title'>Programming Languages & Frameworks</h3>

    <div className='skill__box'>
        <div className='skills__group'>
            <div className='skills__data'>
            <i class='bx bx-code'></i>
                            <div>
                    <h3 className='skills__name'>Python</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-code'></i>
                <div>
                    <h3 className='skills__name'>C/C++</h3>
                    <span className='skills__level'> </span>
                </div>
            </div>
            
            <div className='skills__data'>
            <i class='bx bx-code'></i>
                <div>
                    <h3 className='skills__name'>Java</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-code'></i>
                <div>
                    <h3 className='skills__name'>R</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
        </div>
        <div className='skills__group'>
            <div className='skills__data'>
            <i class='bx bx-code' ></i>
                <div>
                    <h3 className='skills__name'>Django</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-code' ></i>
                <div>
                    <h3 className='skills__name'>Flask</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-code' ></i>
                <div>
                    <h3 className='skills__name'>FastApi</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-code' ></i>
                <div>
                    <h3 className='skills__name'>Jam.py</h3>
                </div>
            </div>
            
            
        </div>
        
    </div>
</div>


  )
}

export default Backend